interface TaskProgressProps {
  percentage: number;
}

export default function TaskProgress({ percentage }: TaskProgressProps) {
  const getProgressColor = (percentage: number) => {
    if (percentage < 33) return 'bg-rose-500';
    if (percentage < 66) return 'bg-amber-400';
    if (percentage < 100) return 'bg-emerald-400';
    return 'bg-emerald-500';
  };

  return (
    <div className="flex items-center gap-3">
      <div className="relative w-32 h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div
          className={`absolute left-0 top-0 h-full transition-all duration-500 ease-out ${getProgressColor(percentage)}`}
          style={{
            width: `${percentage}%`,
            transform: percentage === 0 ? 'translateX(-100%)' : 'translateX(0)'
          }}
        />
      </div>
      <span className={`text-sm font-medium transition-colors duration-200
        ${percentage < 33 ? 'text-rose-500' : ''}
        ${percentage >= 33 && percentage < 66 ? 'text-amber-500' : ''}
        ${percentage >= 66 && percentage < 100 ? 'text-emerald-500' : ''}
        ${percentage === 100 ? 'text-emerald-600' : ''}
      `}>
        {percentage}%
      </span>
    </div>
  );
}
